export default {
  dk: '🇩🇰 Denmark',
  se: '🇸🇪 Sweden',
  no: '🇳🇴 Norway',
  fi: '🇫🇮 Finland',
  de: '🇩🇪 Germany',
  es: '🇪🇸 Spain',
  gb: '🇬🇧 United Kingdom',
  at: '🇦🇹 Austria'
}